import { OAUTH_HEADER_NAME } from '../../../constants';
import * as basicFacade from '../../../facade';
import { withRefreshTokenFacadeFactory } from '../../factory';
import obtainAccessToken from '../obtainOAuthAccessToken';
import { withDisabledRefreshTokenFacade } from '../withDisabledRefreshTokenFacade';
/**
 * REST API oauth2 facade decorator, that adds refresh token authorization feature, build using facadeDecoratorFactory.
 *
 * In module @gef-ui/middleware-api/auth/oauth2/facade are available these refresh decorated actions:
 * - postFormEncoded
 * - postMultipartForm
 * - postApplicationJson
 * - putApplicationJson
 * - patchApplicationJson
 * - getData
 * - postData
 * - deleteData
 *
 * @documented
 * @category oauth2FacadeDecorator
 *
 * @param wrapped
 * @returns wrapped action
 */ export const withOAuthRefreshToken = withDisabledRefreshTokenFacade(withRefreshTokenFacadeFactory(obtainAccessToken, {
    authHeaderName: OAUTH_HEADER_NAME
}));
export const postFormEncoded = withOAuthRefreshToken(basicFacade.postFormEncoded);
export const postMultipartForm = withOAuthRefreshToken(basicFacade.postMultipartForm);
export const postApplicationJson = withOAuthRefreshToken(basicFacade.postApplicationJson);
export const putApplicationJson = withOAuthRefreshToken(basicFacade.putApplicationJson);
export const patchApplicationJson = withOAuthRefreshToken(basicFacade.patchApplicationJson);
export const getData = withOAuthRefreshToken(basicFacade.getData);
export const postData = withOAuthRefreshToken(basicFacade.postData);
export const deleteData = withOAuthRefreshToken(basicFacade.deleteData);
